<template>
  <v-card outlined :class="mobileBereakPoint ? 'mx-1' : 'mr-3'">
    <v-card-text >
      <v-expansion-panels
        flat
        accordion
        v-model="panel"
        tile
        v-if="mobileBereakPoint"
      >
        <v-expansion-panel>
          <v-expansion-panel-header class="clearExpansinHeaderPadding">
            {{getTranslation('Select option')}}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <FilterBuilder
              :formElements="elements"
              @apiResponded="setIncidentsValue"
              :endPoint="'reports/incidents'"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <template v-else >
        <FilterBuilder
          :formElements="elements"
          @apiResponded="setIncidentsValue"
          :endPoint="'reports/incidents'"
        />
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import store from '@/store/store'
import FilterBuilder from '@/components/v2/FilterBuilder'
import translate from '@/utils/genTable/multilanguageHelper.js'

export default {
  name: 'IncidentReportFilter',
  components: {
    FilterBuilder
  },
  data() {
    return {
      panel: 0,
      dataExtraction: {
        dataProperty: 'items',
        totalItemsProperty: 'totalCount'
      },
      messages: {
        deleteConfirmMessage: '$confirmDelete',
        deleteYes: '$yes',
        deleteNo: '$no'
      },
      filters: [{ key: 'keyword', cols: 3 }],
      excludedHeaders: ['id', 'identifier', 'vehicleIds'],
      elements: [
        {
          key: 'IncidentName',
          cols: 12,
          component: 'v-autocomplete',
          dataSource: {
            endpoint: '/lookup/incidenttypes',
            textProperty: 'name',
            valueProperty: 'value'
          },
          label: '$incidentTypes'
        },
        {
          key: 'Groups',
          affects: [
            {
              key: 'vehicleIds',
              change: {
                type: 'dataSource',
                api: {
                  endpoint: '/vehicles?GroupIds=',
                  associateValue: true
                }
              }
            }
          ],
          cols: 12,
          component: 'v-autocomplete',
          dataSource: { endpoint: '/lookup/vehiclegroups' },
          label: '$groups',
          props: {
            multiple: true
          }
        },
        {
          key: 'vehicleIds',
          cols: 12,
          component: 'VSelectAll',
          dataSource: { endpoint: '/vehicles' },
          label: '$vehicles',
          props: {
            multiple: true
          }
        }
      ]
    }
  },
  methods: {
    setIncidentsValue(data) {
      this.panel = 1
      store.dispatch('incidents/setIncidents', data)
    },
    getTranslation(toTranslate) {
      return translate(toTranslate, 'fields')
    }
  },
  computed: {
    mobileBereakPoint() {
      //sm and down
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  beforeDestroy() {
    store.dispatch('incidents/setIncidents', [])
  }
}
</script>

<style scoped>
.clearColumnPadding {
  padding: 0px;
}
</style>
